export const CLIENT_ADMIN_ROLES = ["Client Admin"] as const;

export const CLIENT_HOME_ROLES = [
  "Customer User",
  "Client Admin",
  "Client Accounting",
  "Client Operations",
  "Client Processors",
  "Diligent Search User",
  "State Reporter",
] as const;

/**
 * UserRoles.RoleId values that represent client-side users across environments
 * (aligns with Message Center sender attribution).
 */
export const CLIENT_PORTAL_ROLE_IDS: readonly number[] = [1, 6, 8, 9, 10, 11, 12, 13];

export function isClientPortalRoleId(roleId: number | string | undefined | null): boolean {
  if (roleId == null || roleId === "") return false;
  const id = typeof roleId === "number" ? roleId : Number(roleId);
  if (Number.isNaN(id)) return false;
  return CLIENT_PORTAL_ROLE_IDS.includes(id);
}

export const splitRoles = (userRoles?: string): string[] => {
  if (!userRoles) return [];
  return userRoles
    .split(",")
    .map((role) => role.trim())
    .filter(Boolean);
};

export const hasAnyRole = (
  userRoles?: string,
  allowedRoles: readonly string[] = []
): boolean => {
  const roles = splitRoles(userRoles);
  return roles.some((role) => allowedRoles.includes(role));
};

/** Client portal / home-area users (same list used for layout routing and document–message name masking). */
export const isClientHomeRole = (userRoles?: string): boolean => {
  return hasAnyRole(userRoles, CLIENT_HOME_ROLES);
};

/** Client portal: Non-Premium Endorsements page (upload + prior submissions). */
export const isClientAdmin = (userRoles?: string): boolean => {
  return hasAnyRole(userRoles, CLIENT_ADMIN_ROLES);
};

/** MISC filing queue: view and mark complete non-premium endorsements. */
export const MISC_NON_PREMIUM_VIEW_ROLES = [
  "Super Admin",
  "MISC Filer",
  "MISC State Reporter",
] as const;

export const MISC_NON_PREMIUM_COMPLETE_ROLES = MISC_NON_PREMIUM_VIEW_ROLES;

export const isMiscNonPremiumViewer = (userRoles?: string): boolean => {
  return hasAnyRole(userRoles, MISC_NON_PREMIUM_VIEW_ROLES);
};

export const canMarkMiscNonPremiumComplete = (userRoles?: string): boolean => {
  return hasAnyRole(userRoles, MISC_NON_PREMIUM_COMPLETE_ROLES);
};

export const isSuperAdminRole = (userRoles?: string): boolean => {
  return hasAnyRole(userRoles, ["Super Admin"]);
};
